import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms';
@Component({
  selector: 'datos-hermanos',
  template: `
  <form name="form-inscripciones" [formGroup]="hermanos">
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Varones: <span class="text-danger">*</span> </label>
      <div class="col-sm-1">
        <div
            class="input-group input-group-sm"
            [ngClass]="{'showError': !hermanos.get('varones').valid && hermanos.get('varones').touched}" >
            <input
            type="text"
            [style.border-radius]="'0px'"
            class="form-control"
            formControlName="varones"
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
              Mujeres: <span class="text-danger">*</span> </label>
      <div class="col-sm-1">
          <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !hermanos.get('mujeres').valid && hermanos.get('mujeres').touched}" >
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="mujeres"
              >
          </div>
      </div>
      <label class="col-sm-4 col-form-label text-right">
              Lugar que ocupa entre sus hermanos <span class="text-danger">*</span> </label>
      <div class="col-sm-1">
          <div
              class="input-group input-group-sm mb-1"
              [ngClass]="{'showError': !hermanos.get('lugar').valid && hermanos.get('lugar').touched}" >
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="lugar"
              >
          </div>
      </div>

    </div>
  </form>
  `,
  styles: []
})
export class DatosHermanosComponent implements OnInit {
  @Input() hermanos:FormGroup
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-hermanos.component.ts